module.exports = {"340271001":"龙山街道","340271002":"万春街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340271.json
// module id = 1161
// module chunks = 0